import { connect } from 'react-redux'
import Scoreboard from '../components/Scoreboard'

const getBoardStandings = (standings, title) => {
  switch (title) {
    case 'winners':
      return standings['winners']
    case 'losers':
      return standings['losers']
    default:
      throw new Error('Unknown board: ' + title)
  }
}

const mapStateToProps = (state, ownProps) => ({
  standings:  getBoardStandings(state.standings, ownProps.title),
  title: ownProps.title
})

const RankedScoreboard = connect(
  mapStateToProps
)(Scoreboard)

export default RankedScoreboard
